module.exports = __webpack_public_path__ + "img/logos_sn_221.20f63666.png";